import { render, staticRenderFns } from "./PostFAQ.vue?vue&type=template&id=712ac62c&scoped=true&"
import script from "./PostFAQ.vue?vue&type=script&lang=js&"
export * from "./PostFAQ.vue?vue&type=script&lang=js&"
import style0 from "./PostFAQ.vue?vue&type=style&index=0&id=712ac62c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712ac62c",
  null
  
)

export default component.exports